//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../cell/Index.vue";
import HiButton from "../../button/Index.vue";

export default {
  name: "PlanInstagramUserItemComponent",
  components: { HiCell, HiButton },
  props: {
    // 图片地址
    image: {
      type: String,
    },
    // 用户姓名
    username: {
      type: String,
    },
    // 剩余schedule
    autoPost: {
      type: String,
    },
    // 类型 remove:右侧为删除按钮，member:右侧为所属账号，select：可选择模式
    type: {
      type: String,
      default: "normal",
    },
    member: {
      type: String,
      default: "",
    },
    // 选中状态
    select: {
      type: Boolean,
      default: false,
    },
    socialNetwork: {
      type: Number,
      required: true,
    },
  },
  methods: {
    /**
     * 整个组件点击事件
     */
    itemClick() {
      if (this.type === "select" || this.type === "unselect") {
        this.$emit("click");
      }
    },
    /**
     * 删除按钮点击事件
     */
    removeClick() {
      this.$emit("click");
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/plan/instagram_user_item/Index.vue